import { Button, Card, Row, Col } from 'react-bootstrap';
import React, { useEffect, useRef , useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { getCourseInstructor } from "../../api/utils";

const InstructorProfile = (props) => {
  const {data} = props;
  const [loadingData, setLoadingData] = useState(true);
  const [instructorProfileData, setInstructorData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [instructorData] = await Promise.all([
          getCourseInstructor(data)
        ]);
  
        if (instructorData.status) {
          if(instructorData.data.length == 0){
            setInstructorData([])
          }
          setInstructorData(instructorData.data);
          setLoadingData(false);
        }
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };
  
    if (data) {
      fetchData();
    }
  }, [data]);
  return (
    <>{
      loadingData || instructorProfileData.length == 0 ? <></>:
      <div className='mt-8  h-50'>
        <span className='text-center'><h1 className="fw-bold text-grey">Instructor</h1></span>
        <Row className="align-items-start mt-4">
          {/* Left - Image and button */}
          <Col md={3} className='mr-3'>
            <Card className="p-3 shadow-sm rounded-4 text-center bg-secondary-1 bd-sec">
              <Card.Img
                variant="top"
                src={instructorProfileData['image']}
                alt="Instructor"
                className="rounded-4"
              />
              <Button variant="primary" className="primary-button rounded-4 mt-3 px-4 py-2 fw-semibold">
                View Profile &nbsp; →
              </Button>
            </Card>
          </Col>

          {/* Right - Details */}
          <Col md={8}>
            <h4 className="fw-bold mb-1">{instructorProfileData['name']}</h4>
            <p className="text-muted">{instructorProfileData['subject']} Professor | {instructorProfileData['experience']} years experience | {instructorProfileData['university']}</p>
            {/* <p className="text-secondary" style={{ lineHeight: '1.8' }}>
              We are the expert SAT coaching in Dubai with proven results. Join UAE’s premier institute
              for personalised test prep, experienced tutors, and comprehensive study programs. Book
              your free assessment today. We are the expert SAT coaching in Dubai with proven results.
              Join UAE’s premier institute for personalised test prep, experienced tutors, and
              comprehensive study programs. Book your free assessment today.
            </p> */}
             <div className="container mt-4">
                <h5 className="mb-3">Credentials</h5>
                <ul className="list-group">
                  {instructorProfileData['credentials'].map((item, index) => (
                    <li key={index} className="list-group-item">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="container mt-4">
                <h5 className="mb-3">Achievements</h5>
                <ul className="list-group">
                  {instructorProfileData['achievments'].map((item, index) => (
                    <li key={index} className="list-group-item">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            {/* <p className="text-secondary" style={{ lineHeight: '1.8' }}>
              We are the expert SAT coaching in Dubai with proven results. Join UAE’s premier institute
              for personalised test prep, experienced tutors, and comprehensive study programs. Book
              your free assessment today. We are the expert SAT coaching in Dubai with proven results.
              Join UAE’s premier institute for personalised test prep, experienced tutors, and
              comprehensive study programs. Book your free assessment today.
            </p> */}
          </Col>
        </Row>
      </div>
    }
    </>
  );
};

export default InstructorProfile;
